import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ExpirationDownIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.29908 15.4882C8.6664 15.9862 9.09754 16.4235 9.59247 16.8C10.0874 17.1804 10.6307 17.4745 11.2223 17.6824C11.8139 17.8941 12.4345 18 13.084 18C13.8922 18 14.652 17.8431 15.3634 17.5294C16.0788 17.2156 16.7091 16.7823 17.2542 16.2294C17.7994 15.6764 18.2267 15.0392 18.5361 14.3176C18.8454 13.5922 19 12.8196 19 12C19 11.1804 18.8454 10.4098 18.5361 9.68824C18.2267 8.96274 17.7994 8.32353 17.2542 7.77059C16.7091 7.21765 16.0788 6.78431 15.3634 6.47059C14.652 6.15686 13.8922 6 13.084 6C12.2759 6 11.5142 6.15686 10.7989 6.47059C10.0874 6.78431 9.45906 7.21765 8.91387 7.77059C8.36867 8.31961 7.94141 8.95686 7.63208 9.68235C7.32274 10.4039 7.16808 11.1745 7.16808 11.9941M7.16808 11.9941L6 9.68235M7.16808 11.9941L9.26072 10.0759M13.084 8.57143V12L15.5333 14.5714"
            stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)
const ExpirationDownIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ExpirationDownIconSvg}
    </SvgIcon>
);
export default ExpirationDownIcon
